import React from 'react';
import { Form, FormFeedback, Input } from 'reactstrap';
import { BaseCustomModal, GradientDecorationLine, BaseCustomButton, BaseCustomTextArea } from '../../../shared';
import { useFormik } from "formik";
import * as Yup from "yup";

export const EmaRegulationRegisterModal = ({ setShowModal, showModal, modalRespInfo, isUpdate, rowInfo, modalClose }) => {

    const formikFormData = useFormik({
        enableReinitialize: true,
        initialValues: {
            section: isUpdate ? rowInfo.section : '',
            development: isUpdate ? rowInfo.development : '',
        },
        validationSchema: Yup.object({
            section: Yup.string().required("Ingrese la sección"),
            development: Yup.string().required("Ingrese la descripción"),
        }),
        onSubmit: (values, { resetForm }) => {
            modalRespInfo(values);
            resetForm();
            setShowModal(false);
        }
    });

    const onClosed = () => {
        formikFormData.resetForm();
        modalClose();
        setShowModal(false);
    };

    const children_form = (
        <div>
            <h4 className="text-primary m-0 ps-4">Registro/Actualización de Normativa ema</h4>
            <GradientDecorationLine />
            <Form
                className="form-horizontal mt-3 mb-1"
                onSubmit={(e) => {
                    e.preventDefault();
                    formikFormData.handleSubmit();
                    return false;
                }}
            >
                <div className="mb-3 px-5">
                    <label className='text-primary'>Nombre de la Sección</label>
                    <Input
                        placeholder="Sección"
                        type="text"
                        {...formikFormData.getFieldProps('section')}
                        name="section"
                        className="form-control text-primary rounded-3"
                        invalid={formikFormData.touched.section && !!formikFormData.errors.section}
                    />
                    {formikFormData.errors.section && <FormFeedback>{formikFormData.errors.section}</FormFeedback>}
                </div>
                <div className="mb-3 px-5">
                    <label className='text-primary'>Descripción</label>
                    <BaseCustomTextArea
                        name="development"
                        placeholder="Descripción"
                        rows="9"
                        className={`form-control text-primary rounded-3 ${formikFormData.touched.development && formikFormData.errors.development ? 'is-invalid' : ''}`}
                        {...formikFormData.getFieldProps('development')}
                    />
                    {formikFormData.touched.development && formikFormData.errors.development && (
                        <FormFeedback>{formikFormData.errors.development}</FormFeedback>
                    )}
                </div>
                <div className='mt-5'>
                    <GradientDecorationLine />
                    <div className="page-title-box d-flex justify-content-end">
                        <BaseCustomButton
                            outline
                            color="primary"
                            className='rounded-3 me-4'
                            onClick={formikFormData.handleSubmit}
                            label="Guardar"
                            icon="mdi mdi-content-save me-1"
                        />
                        <BaseCustomButton
                            outline
                            color="danger"
                            className='rounded-3'
                            onClick={() => { onClosed() }}
                            label="Cancelar"
                            icon="mdi mdi-close-circle-outline me-1"
                        />
                    </div>
                </div>
            </Form>
        </div>
    );

    return (
        <BaseCustomModal
            isModalOpen={showModal}
            handleCancel={onClosed}
            footer={null}
            children={children_form}
            width={900}
        />
    );
};
